module.exports = __webpack_public_path__ + "img/card_front.91cdd216.png";